import anime from 'animejs';

export function initFactbox(wrapper = document){
    for(const factbox of wrapper.querySelectorAll('.factbox')){

        const contentItems = factbox.querySelectorAll('.factbox__contentItem');
        const mediaItems = factbox.querySelectorAll('.factbox__mediaItem');

        // Hide all media items initially except the first one
        mediaItems.forEach((item, index) => {
            if (index !== 0) {
                item.style.display = 'none';
            }
        });

        // Hide all content info items initially
        const allContentInfos = factbox.querySelectorAll('.factbox__contentItemInfo');
        allContentInfos.forEach(info => {
            info.style.height = '0';
            info.style.overflow = 'hidden';
            info.style.paddingTop = '0';
            info.style.paddingBottom = '0';
        });

        // Add click event to each content item
        contentItems.forEach((contentItem, itemIndex) => {
            contentItem.addEventListener('click', function() {
                const contentInfo = this.querySelector('.factbox__contentItemInfo');
                const wasActive = this.classList.contains('is-active');

                // Scroll to factbox start if not visible in viewport
                const factboxRect = factbox.getBoundingClientRect();
                if (factboxRect.top < 0) {
                    factbox.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }

                // Collapse all other content info items
                contentItems.forEach(item => {
                    if (item !== this && item.classList.contains('is-active')) {
                        const otherInfo = item.querySelector('.factbox__contentItemInfo');
                        item.classList.remove('is-active');
                        if (otherInfo) {
                            anime({
                                targets: otherInfo,
                                height: 0,
                                paddingTop: 0,
                                paddingBottom: 0,
                                duration: 300,
                                easing: 'easeInOutQuad'
                            });
                        }
                    }
                });

                // Toggle active class on clicked item
                if (!wasActive) {
                    this.classList.add('is-active');
                } else {
                    this.classList.remove('is-active');
                }

                // Hide all media items
                mediaItems.forEach(item => {
                    item.style.display = 'none';
                });

                // Show the corresponding media item by index
                if (mediaItems[itemIndex] && !wasActive) {
                    mediaItems[itemIndex].style.display = 'flex';
                } else if (wasActive && mediaItems[0]) {
                    // Show first media item when closing
                    mediaItems[0].style.display = 'flex';
                }

                // Toggle the clicked content info
                if (contentInfo) {
                    if (!wasActive) {
                        // Make visible before measuring
                        contentInfo.style.display = 'block';

                        // First, temporarily remove inline styles to get the natural values from CSS
                        contentInfo.style.removeProperty('height');
                        contentInfo.style.removeProperty('padding-top');
                        contentInfo.style.removeProperty('padding-bottom');

                        // Get natural height and padding from CSS
                        const targetHeight = contentInfo.offsetHeight;
                        const computedStyle = window.getComputedStyle(contentInfo);
                        const targetPaddingTop = computedStyle.paddingTop;
                        const targetPaddingBottom = computedStyle.paddingBottom;

                        // Now set to 0 for animation start
                        contentInfo.style.height = '0';
                        contentInfo.style.paddingTop = '0';
                        contentInfo.style.paddingBottom = '0';

                        // Expand
                        anime({
                            targets: contentInfo,
                            height: targetHeight,
                            paddingTop: targetPaddingTop,
                            paddingBottom: targetPaddingBottom,
                            duration: 300,
                            easing: 'easeInOutQuad',
                            complete: () => {
                                contentInfo.style.removeProperty('height');
                                contentInfo.style.removeProperty('padding-top');
                                contentInfo.style.removeProperty('padding-bottom');
                            }
                        });
                    } else {
                        // Collapse
                        anime({
                            targets: contentInfo,
                            height: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            duration: 300,
                            easing: 'easeInOutQuad'
                        });
                    }
                }
            });
        });

        // Activate the first item on load without click
        if (contentItems.length > 0 && allContentInfos.length > 0) {
            const firstItem = contentItems[0];
            const firstInfo = allContentInfos[0];

            firstItem.classList.add('is-active');

            // Set first content info to open state without animation
            firstInfo.style.removeProperty('height');
            firstInfo.style.removeProperty('padding-top');
            firstInfo.style.removeProperty('padding-bottom');
        }
    }
}